(() => {
  let cleanup;

  function initAutumnLeaves() {
    cleanup?.();
    const layer = document.querySelector('[data-sfny-autumn-leaves]');
    if (!layer) return;

    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const { signal } = controller;
    let frame;

    const update = () => {
      frame = null;
      const target = document.querySelector('[data-scent-discovery]') ||
        Array.from(document.querySelectorAll('mood-board-section')).find((section) =>
          section.querySelector('.mood-board__heading')?.textContent.trim().toLowerCase() === 'scent discovery'
        );
      const height = Math.max(window.innerHeight, 1);
      const opacity = motion.matches ? 0 : target
        ? Math.min(1, Math.max(0, (target.getBoundingClientRect().top - height * .75) / (height * .65)))
        : 1;
      layer.style.setProperty('--sfny-leaf-opacity', opacity.toFixed(3));
      layer.style.visibility = opacity <= .01 ? 'hidden' : 'visible';
      layer.dataset.paused = String(opacity <= .01 || document.hidden);
    };

    const requestUpdate = () => {
      if (frame == null) frame = requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true, signal });
    window.addEventListener('resize', requestUpdate, { passive: true, signal });
    document.addEventListener('visibilitychange', requestUpdate, { signal });
    motion.addEventListener('change', requestUpdate, { signal });
    const observer = new ResizeObserver(requestUpdate);
    observer.observe(document.body);
    cleanup = () => {
      controller.abort();
      observer.disconnect();
      cancelAnimationFrame(frame);
    };
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutumnLeaves, { once: true });
  } else {
    initAutumnLeaves();
  }
  document.addEventListener('shopify:section:load', initAutumnLeaves);
  document.addEventListener('shopify:section:unload', initAutumnLeaves);
})();
